import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/pro-regular-svg-icons/faVideo";

export const defaultTranslations = {
    pluginName: "Video Carousel",
    pluginDescription: "Add videos",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faVideo} size="3x" />,
};
